import { Component, OnInit, Input, ViewChildren, QueryList } from '@angular/core';
import { JPathService } from '@cv-invision/cv.component-library.ux';
import { Store } from '@ngxs/store';
import { assign, merge } from 'lodash';
// States
import { QualityState } from '../../state/quality.state';
// Components
import { InReviewFieldsComponent } from '../in-review-fields/in-review-fields.component';

@Component({
	selector: 'cv-in-review-static-tables',
	templateUrl: './in-review-static-tables.component.html',
	styleUrls: ['./in-review-static-tables.component.scss']
})
export class InReviewStaticTablesComponent implements OnInit {
	// @ViewChildren('fields') myFields: QueryList<InReviewFieldsComponent>;

	@Input() field: any;
	@Input() selectedType = '';
	@Input() selectedTargets: any;

	constructor(
		private store: Store,
		private jPathService: JPathService
	) {
	}

	async ngOnInit(): Promise<void> {
		if ('comparables' in this.field.options) {
			const document = this.store.selectSnapshot(QualityState.getOrderDocument);
			const comparables = this.jPathService.getValue(document, `$.${this.field.options.comparables}`);
			const oldCols = merge([], this.field.options.rows[0].cols);
			const rows = [];

			await comparables.forEach((element, compIndex) => {
				const cols = [];
				oldCols.forEach((col, colIndex) => {
					const nCol: any = merge({}, oldCols[colIndex]);
					if (compIndex === 0 && colIndex === 0) {
						nCol.options.label = 'Subject';
					} else if (compIndex > 0 && colIndex === 0) {
						nCol.options.label += compIndex;
					}

					if ('path' in nCol.options) {
						const pathPattern = /(\[[a-zA-z=0-9'\\]+\])/g;
						const newPath = nCol.options.path.replace(pathPattern, match => {
							const splitedValues = match.replace(/[[]']+/g, '').split('=');
							const pathString = '[' + splitedValues[0] + '=' + compIndex + ']';

							return pathString;
						});
						nCol.options.path = newPath;
					}
					cols.push(nCol);
				});
				rows.push(Object.assign({ cols: cols }));
			});
			this.field.options.rows = rows;
		}
	}

}
